import { MasterHelper } from '../../utilities';
import { AdditionalFilter } from '../rulebook/additional-filter';

export class SelfAssessmentT2Filter extends AdditionalFilter {
    fromDate: string=""; 
    toDate: string=MasterHelper.getDateStr(0);
    ruleBook: string[];
    part: string[];
    owner: string[];
    regulatoryRuleFullRequirement:string[];
    assessmentTeam: string[];
    assessmentDetails: string[];
    assessmentStatus: string[];
    complianceStatus: string[];
    reviewDate:string="";
    assessmentDate:string="";
    lbgImpact:string="";
    lbcmImpact:string="";
    rfbImpact:string="";
    nextassessmentDue:string="";
    reviewerTeam: string[];
    reviewDetails: string[];
    reviewStatus: string[];
   
    interpretation: string[];
    interpretationDetails: string[];

    judgement:string[];
    // noOfJudgements:number;
    judgementDetails:string[];

    gaps: string[];
    gapDetail: string[];
    // noOfGaps: number;

    enhancement: string[];
    enhancementDescription: string[];
    // noOfEnhancement: number;

    approvalTeam:string[];
    approvalStatus:string[];
    approvalComment:string[];

    searchQuery: string[];
    rulebookRuleID:string;

    constructor() {
        super();
        this.fromDate = "";
        this.toDate = MasterHelper.getDateStr(0);
        this.ruleBook = [];
        this.part = [];
        this.owner = [];
        this.regulatoryRuleFullRequirement = [];
        this.assessmentTeam = [];
        this.assessmentDetails = [];
        this.assessmentStatus = [];
        this.reviewerTeam = [];
        this.reviewDetails = [];
        this.reviewStatus = [];
        this.complianceStatus = [];
        this.interpretation = [];
        this.interpretationDetails = [];
        this.judgement = [];
        this.judgementDetails = [];
        this.gaps = [];
        this.gapDetail = [];
        this.enhancement = [];
        this.enhancementDescription = [];
        this.approvalTeam = [];
        this.approvalStatus = [];
        this.approvalComment = [];
        // this.noOfEnhancement = 0;
        // this.noOfGaps = 0;
        // this.noOfJudgements = 0;
        this.searchQuery = [];
        this.rulebookRuleID = '';
    }
}
